export default __webpack_public_path__ + "static/media/flyback_controller_dc_psr.f97524a3.svg";